import { render } from "./Profile.vue?vue&type=template&id=4f5efcff&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=4f5efcff&scoped=true&lang=css"

import exportComponent from "/Users/bahramhasanov/Downloads/_TRASH/loyalty/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5efcff"]])

export default __exports__